import React from 'react'
import { connect } from 'react-redux'
import './loadingAnimation.scss';
import loaderImg from '../../../assests/images/small-loader.gif';

let LoadingAnimation = props => {
    const { isLoading } = props;
    return (
        <div>
            {isLoading &&
                <div className="loader-container">
                    <img src={loaderImg} />
                </div>

            }
        </div>
    )
};

LoadingAnimation = connect((store, oprops) => ({
    isLoading: store.loader.isLoading
})
)(LoadingAnimation)


export default LoadingAnimation;
